
import { useState } from "react";
import "./DateRangeComponent1.css"
import { DateRangePicker } from "react-date-range";

import {
    addDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays,
    format,
    isWeekend,
    differenceInDays
} from 'date-fns';
import { useEffect } from "react";
const DateRangeComponent = ({ range, apply, minDate, maxDate, setDateToggle}) => {


    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });


    useEffect(() => {
        setSelectionRange({
            startDate: range.startDate,
            endDate: range.endDate,
            key: 'selection',
        });

    }, []);



    const handleSelect = (ranges) => {
        setSelectionRange(ranges.selection);
    };

    function customDayContent(day) {
        // let extraDot = null;
        // if (isWeekend(day)) {
        //     extraDot = (
        //         <div
        //             style={{
        //                 height: "5px",
        //                 width: "5px",
        //                 borderRadius: "100%",
        //                 background: "orange",
        //                 position: "absolute",
        //                 top: 2,
        //                 right: 2,
        //             }}
        //         />
        //     )
        // }
        return (
            <div>
                {/* {extraDot} */}
                <span style={{
                    color: (() => {
                        if (format(day, 'yyyy-MM-dd') === format(selectionRange.startDate, 'yyyy-MM-dd') || format(day, 'yyyy-MM-dd') === format(selectionRange.endDate, 'yyyy-MM-dd')) {
                            return "white"
                        } else {
                            return "black"
                        }
                    })()
                }}  >{format(day, "d")}</span>
            </div>
        )
    }




    const handleApply = () => {
        apply({

            startDate: selectionRange.startDate,
            endDate: selectionRange.endDate

        });
        setDateToggle(false);
    }

    const defineds = {
        startOfWeek: startOfWeek(new Date()),
        endOfWeek: endOfWeek(new Date()),
        startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
        endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
        startOfToday: startOfDay(new Date()),
        endOfToday: endOfDay(new Date()),
        startOfYesterday: startOfDay(addDays(new Date(), -1)),
        endOfYesterday: endOfDay(addDays(new Date(), -1)),
        startOfMonth: startOfMonth(new Date()),
        endOfMonth: endOfMonth(new Date()),
        startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
        endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    };

    function createStaticRanges(ranges) {
        return ranges.map(range => ({ ...staticRangeHandler, ...range }));
    }

    const staticRangeHandler = {
        range: {},
        isSelected(range) {
            const definedRange = this.range();
            return (
                isSameDay(range.startDate, definedRange.startDate) &&
                isSameDay(range.endDate, definedRange.endDate)
            );
        },
    };



    const defaultStaticRanges = createStaticRanges(
        [
            {
                label: 'Today',
                range: () => ({
                    startDate: defineds.startOfToday,
                    endDate: defineds.endOfToday,

                }),
            },
            {
                label: 'Yesterday',
                range: () => ({
                    startDate: defineds.startOfYesterday,
                    endDate: defineds.endOfYesterday,

                }),
            },
            {
                label: 'Last 7 days',
                range: () => ({
                    startDate: addDays(new Date(), -7),
                    endDate: addDays(new Date(), -1),

                }),
            },
            {
                label: 'Last 14 days',
                range: () => ({
                    startDate: addDays(new Date(), -14),
                    endDate: addDays(new Date(), -1),

                }),
            },
            {
                label: 'Last 30 days',
                range: () => ({
                    startDate: addDays(new Date(), -30),
                    endDate: addDays(new Date(), -1),

                }),
            },
            {
                label: 'This Week',
                range: () => ({
                    startDate: defineds.startOfWeek,
                    endDate: defineds.endOfWeek,
                }),
            },
            {
                label: 'Last Week',
                range: () => ({
                    startDate: defineds.startOfLastWeek,
                    endDate: defineds.endOfLastWeek,
                }),
            },
            {
                label: 'This Month',
                range: () => ({
                    startDate: defineds.startOfMonth,
                    endDate: defineds.endOfMonth,
                }),
            },
            {
                label: 'Last Month',
                range: () => ({
                    startDate: defineds.startOfLastMonth,
                    endDate: defineds.endOfLastMonth,
                }),
            },

        ]
    );
    return (
        <div style={{ userSelect: "none", display: "flex", flexDirection: "column", paddingTop: 24, paddingBottom: 24, backgroundColor: "white", boxShadow: "0px 4px 16px 6px rgba(130, 130, 130, 0.05)" }} >

            <div style={{}} >
                <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={handleSelect}
                    minDate={minDate}
                    maxDate={maxDate}
                    // months={2}
                    // direction='horizontal'
                    inputRanges={[]}
                    staticRanges={defaultStaticRanges}
                    dayContentRenderer={customDayContent}

                />

            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }} >
                <div style={{ display: "flex", justifyContent: "space-between", width: 352, borderLeft: "1px solid rgb(239, 242, 247)" }} >
                    <div style={{ marginLeft: 16 }}>
                        <div style={{ color: "#97979A", fontSize: 12, letterSpacing: 1.6 }} >SELECTED DAYS</div>
                        <div style={{ fontSize: 14, fontWeight: 600, lineHeight: "20px", marginTop: 8 }} >

                            {format(selectionRange?.startDate, 'dd/MM/yyyy')} - {format(selectionRange?.endDate, 'dd/MM/yyyy')}


                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", marginRight: 16 }} >
                        <div style={{ color: "#97979A", fontSize: 12, letterSpacing: 1.6 }} >DAYS</div>
                        <div style={{ fontSize: 14, fontWeight: 600, lineHeight: "20px", marginTop: 8 }} > {differenceInDays(selectionRange.endDate, selectionRange.startDate) + 1} DAYS</div>
                    </div>
                </div>

                <div style={{ width: 352, marginTop: 24 }} >

                    <div style={{ display: "flex", justifyContent: "space-between", marginLeft: 16, marginRight: 16 }} >
                        <div style={{
                            display: "flex", alignItems: "center", justifyContent: "center", height: 32, width: 136, borderRadius: 4,
                            border: "1px solid #EAEAED",
                            fontSize: 12, fontStyle: "normal", fontWeight: 700, lineHeight: "18px",
                            cursor: "pointer"
                        }} 
                        onClick={() => setDateToggle(false)}>
                            Cancel
                        </div>
                        <div style={{
                            display: "flex", alignItems: "center", justifyContent: "center", height: 32, width: 136, borderRadius: 4,
                            border: "1px solid #1565C0",
                            backgroundColor: "#1565C0",
                            color: "white",
                            cursor: "pointer",
                            fontSize: 12, fontStyle: "normal", fontWeight: 700, lineHeight: "18px",

                        }}
                            onClick={handleApply}
                        >
                            Apply
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DateRangeComponent;